module.exports = __webpack_public_path__ + "static/media/facebook.8e3ebb3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook.svg
// module id = 353
// module chunks = 1